import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { getSign } from "@/utils/sign/sign";
import { downloadFile, getFileName } from "@/utils/download";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1000 * 10
});

// 请求体拦截器
service.interceptors.request.use(
  async config => {
    if (getToken()) {
      const hash = window.location.hash;
      const parthash = hash.indexOf("?") === -1 ? hash : hash.split("?")[0];

      if (parthash !== "#/login" && `${store.state.user.agreementId}` !== localStorage.getItem("agreementId")) {
        if (!localStorage.getItem("agreementId")) {
          setTimeout(() => {
            store.dispatch("user/resetToken").then(() => {
              sessionStorage.setItem("messageStatus", 0);
              location.reload();
            });
          }, 1000);
          return Promise.reject({ Error: "请重新登录" });
        } else {
          setTimeout(() => {
            location.hash = "#/dashboard";
            location.reload();
          }, 1000);
          return Promise.reject({ Error: "用户已切换，1s后将自动刷新用户数据" });
        }
      }
      config.headers["Authorization"] = getToken();
      if (config.contentType) config.headers["Content-Type"] = config.contentType;
      config.exportFiles ? (config.responseType = "blob") : (config.responseType = "json");
    }
    if (!config.skipSign) {
      const S = await getSign(config.url);
      config.headers["Y-Sign"] = S.si;
      config.headers["Y-A"] = S.a;
      config.headers["Y-P"] = S.p;
      config.headers["Y-R"] = S.u;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应体拦截器
service.interceptors.response.use(
  async response => {
    if (response.config.exportFiles) {
      const contentType = response.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await response.data.text();
        let res;
        try {
          res = JSON.parse(text);
        } catch (e) {
          Message({
            message: "文件下载失败，解析错误",
            type: "error"
          });
          return Promise.reject(e);
        }
        Message({
          message: res.msg || "导出失败",
          type: "error"
        });

        return Promise.reject(res);
      }
      const fileName = getFileName(response.headers["content-disposition"]);
      downloadFile(response.data, contentType, fileName, response.config?.params?.messageTip);
      return { msg: "success" };
    }
    const res = response.data;
    if (response.config.noResponse) {
      return Promise.resolve(res);
    }
    if (res.code === 401) {
      Message({
        message: "请联系技术操作",
        type: "error",
        duration: 5 * 1000
      });
      return Promise.reject(new Error("请联系技术操作"));
    }
    if (res.code !== 200) {
      if (
        res.code === 7000 ||
        res.code === 7100 ||
        res.code === 7101 ||
        res.code === 7102 ||
        res.code === 7103 ||
        res.code === 7104 ||
        res.code === 7105
      ) {
        return res;
      }
      // if (res.msg !== '商户账户暂未开通，请联系平台运营') {
      if (sessionStorage.getItem("messageStatus") !== "1") {
        Message({
          message: res.msg || "系统错误",
          type: "error",
          duration: 5 * 1000
        });
        sessionStorage.setItem("messageStatus", 1);
        setTimeout(() => {
          sessionStorage.setItem("messageStatus", 0);
        }, 1500);
      }
      if (res.code === 4001) {
        // to re-login
        setTimeout(() => {
          store.dispatch("user/resetToken").then(() => {
            sessionStorage.setItem("messageStatus", 0);
            location.reload();
          });
        }, 1000);
      } else {
        return Promise.reject(new Error(res.msg || "系统错误"));
      }
    } else {
      sessionStorage.setItem("messageStatus", 0);
      return res;
    }
  },
  error => {
    if (sessionStorage.getItem("messageStatus") !== "1" && !error.noMsg) {
      Message({
        message: error.Error || "系统错误",
        type: "error",
        duration: 5 * 1000
      });
      sessionStorage.setItem("messageStatus", 1);
      setTimeout(() => {
        sessionStorage.setItem("messageStatus", 0);
      }, 3000);
    }
    return Promise.reject(error);
  }
);

export default service;
